
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Updates an existing webhook subscription's delivery configuration.`}</p>
    <p>{`This modifies fields related to the URL and payload of an existing webhook subscription.
Changes may take up to half an hour to take effect.`}</p>
    <p>{`The fields that determine which events are to be delivered are immutable.
A new webhook subscription should be created for such cases.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;